import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { hasSearchParams } from '@/hooks/useFilterQueryParams';

type InitialCaseFromParams = {
  caseId: string;
  caseName: string;
};

type UseInitialCaseFromParamsReturnType = {
  data: InitialCaseFromParams | null;
  clearParams: () => void;
};

export const useInitialCaseFromParams = (): UseInitialCaseFromParamsReturnType => {
  const [searchParams, setSearchParams] = useSearchParams();

  const paramsData = useMemo(() => {
    if (!hasSearchParams(searchParams)) return null;

    const caseId = searchParams.get('caseId');
    const caseName = searchParams.get('caseName');

    if (!caseId || !caseName) return null;

    return {
      caseId,
      caseName,
    };
  }, [searchParams]);

  const clearSearchParams = useCallback(() => {
    searchParams.delete('caseId');
    searchParams.delete('caseName');
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return {
    data: paramsData,
    clearParams: clearSearchParams,
  };
};
